import React, { FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IconButton, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { AnnotaionDto } from '../../dto/LectionImageDto';
import { MyTextFiled } from '../UI/MyTextField';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { DialogConfirmation } from '../confirmation/DialogConfirmation';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  convertHtmlToText,
  convertTextToHtml,
  getDefaultAlertProps,
  getPageNumId,
} from '../../utils/utils';
import { apiDeleteAnnatation } from '../../service/apiDeleteAnnatation';
import { IApiResult } from '../../interface/IApiResult';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { apiAddAnnatation } from '../../service/apiAddAnnatation';
import { MyAlert } from '../UI/MyAlert';

interface Props {
  idPage: string;
  dto: AnnotaionDto;
  onUpdate: () => any;
}

export const WorksapceAnnotationItemDiv: FunctionComponent<Props> = ({
  idPage,
  dto,
  onUpdate,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const [value, setValue] = useState<AnnotaionDto>(dto);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const { section, route } = useParams();
  const page = getPageNumId(idPage);
  const deleteFile = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmation(false);
      return;
    }
    const apiResult: IApiResult = await apiDeleteAnnatation(
      section ?? '',
      route ?? '',
      page ?? '',
      value
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenDialogConfirmation(false);
  };

  const addAnnatattion = async () => {
    const apiResult: IApiResult = await apiAddAnnatation(
      section ?? '',
      route ?? '',
      page ?? '',
      value
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };
  const handleDelete = async () => {
    setOpenDialogConfirmation(true);
  };
  return (
    <div>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack spacing={1}>
        <Stack direction="row" spacing={1}>
          <IconButton size="medium" onClick={() => setIsEdit(!isEdit)}>
            <EditIcon
              fontSize="medium"
              sx={{
                color: '#ff9800',
              }}
            />
          </IconButton>
          <IconButton size="medium" onClick={() => addAnnatattion()}>
            <SaveIcon fontSize="medium" sx={{ color: '#9c27b0' }} />
          </IconButton>
          <IconButton size="medium" onClick={() => handleDelete()}>
            <DeleteIcon
              fontSize="medium"
              sx={{
                color: '#f44336',
              }}
            />
          </IconButton>
        </Stack>

        <MyTextFiled
          value={value.id}
          onChange={(e) => setValue({ ...value, id: e.target.value })}
          size="small"
          disabled
          label="id"
        />

        {false && (
          <MyTextFiled
            value={value.title}
            onChange={(e) => setValue({ ...value, title: e.target.value })}
            size="small"
            disabled={!isEdit}
            label="Термин"
          />
        )}
        <MyTextFiled
          value={convertHtmlToText(value.text)}
          onChange={(e) =>
            setValue({ ...value, text: convertTextToHtml(e.target.value) })
          }
          multiLine
          size="small"
          disabled={!isEdit}
          label="Пояснение"
        />
      </Stack>
      <DialogConfirmation
        open={openDialogConfirmation}
        message="Вы точно хотите удалить данный термин?"
        onClose={deleteFile}
      />
    </div>
  );
};
